<template>
    <!--弹窗-->
    <el-dialog width="600px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="180px" size="mini">
            <div class="top">
                <div style="font-weight: 900;">下载模板</div>
                <div>
                    <a href="/export/防内部竞价模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“防内部竞价”模板</a>
                </div>
            </div>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed='handExceed'
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件</div>
                </el-upload>
            </div>
        </el-form>
        <el-form ref="form" :inline="true" :rules="rules" :model="listData" class="query-form" size="mini" label-width="80px" style="padding: 10px 0 0 100px">
            <!-- <el-form-item label="ASIN: " class="query-form-item" prop="asin">
                <el-input v-model="listData.asin" placeholder="请输入ASIN" clearable style="width: 260px;"></el-input>
            </el-form-item> -->
            <el-form-item label="项目组: " class="query-form-item" prop="project_name">
                <el-input v-model="listData.project_name" placeholder="请输入项目组" clearable style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="国家: " class="query-form-item" prop="state">
                <el-select
                    v-model="listData.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()" style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="类型: " class="query-form-item" prop="type">
                <el-select
                    v-model="listData.type"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in typeArr"
                        :key="item.index"
                        :label="item.title"
                        :value="item.index">
                    </el-option>
                </el-select>
            </el-form-item> -->
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/adv/adv";
export default {
    data() {
        return {
            files: [],
            // typeArr: [
            //     {
            //         index: 1,
            //         title: "广告层面"
            //     },
            //     {
            //         index: 2,
            //         title: "逻辑层面"
            //     }
            // ],
            rules: {
                asin: [
                    {
                        required: true,
                        message: "请输入ASIN",
                        trigger: "blur"
                    }
                ],
                type: [
                    {
                        required: true,
                        message: "请选择类型",
                        trigger: "blur"
                    }
                ],
                project_name: [
                    {
                        required: true,
                        message: "请输入项目组",
                        trigger: "blur"
                    }
                ],
                state: [
                    {
                        required: true,
                        message: "请选择国家",
                        trigger: "blur"
                    }
                ]
            },
            listData: {}
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
            });
            return;
        },
        handFileSuccess() {
            this.files = [];
            this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                    if (this.files.length == 0) {
                        this.$message.warning(`当前限制只能上传选择 1 个文件`);
                        return;
                    }
                    let file = new FormData();
                    file.append("file", this.files[0]);
                    let obj = {
                        project_name: this.listData.project_name,
                        state: this.listData.state
                    };
                    api.prevent_internal_competition_add(obj, file)
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "上传成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.handleClose(true);
                            } else {
                                this.disabled = false;
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                        });
                    // binary_download(
                    //     "/apis/open_ad_group/prevent_internal_competition_add",
                    //     "post",
                    //     {},
                    //     file,
                    //     "application/vnd.ms-excel",
                    //     `防内部竞价分析数据.xlsx`
                    // );
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.handFileSuccess();
            this.$refs["formData"].resetFields();
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
